module.exports = __webpack_public_path__ + "static/media/fortune.588f078d.png";